import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mobile14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M9 4.75H5V3.25H9V4.75Z' fill='currentColor' />
    <path
      d='M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44771 6.44772 9 7 9C7.55228 9 8 9.44771 8 10Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.25 1.375C2.25 0.708819 2.8112 0.25 3.4 0.25H10.6C11.1888 0.25 11.75 0.708819 11.75 1.375V12.625C11.75 13.2912 11.1888 13.75 10.6 13.75H3.4C2.8112 13.75 2.25 13.2912 2.25 12.625V1.375ZM3.75 1.75V12.25H10.25V1.75H3.75Z'
      fill='currentColor'
    />
  </Svg>
);

Mobile14.displayName = 'Mobile14';
export default Mobile14;
